const blog = (function ($) {

  var pub = {};

  pub.init = function () {
    pub._toggleFilters();
  };

  pub._toggleFilters = function () {
    $('.module__blog').on('click', '.taxonomy__name', function(e) {
      e.preventDefault();
      $(this).parent().toggleClass('taxonomy--open');
    });
  };

  return pub;

})(jQuery);
